/* eslint-disable react/default-props-match-prop-types */
import React, { FC } from 'react'
import { currencySymbols } from '@shared/config'
import { useMoneyMask, UseMoneyMaskParams } from '@shared/lib/hooks/useMoneyMask'

export interface MoneyInputProps extends Omit<any, 'onChange' | 'value' | 'inputMode'>, UseMoneyMaskParams {
  currency?: keyof typeof currencySymbols
  /**
   * onChange всегда возвращает строку
   */
  alwaysReturnString?: boolean
}

const MoneyInput: FC<MoneyInputProps> = ({
  onChange,
  onBlur,
  onFocus,
  onKeyUp,
  placeholder,
  currency,
  onClick,
  children,
  value,
  allowDecimal,
  decimalSymbol,
  decimalLimit,
  integerLimit,
  allowLeadingZeroes,
  inputMode,
  alwaysReturnString = false,
}) => {
  const currencySymbol = currencySymbols[currency as 'ALL']

  useMoneyMask({
    prefix: '',
    suffix: ` ${currencySymbol}`,
    thousandsSeparatorSymbol: ' ',
    allowDecimal,
    decimalSymbol,
    decimalLimit,
    integerLimit,
    allowLeadingZeroes,
    placeholder,
    onClick,
    onFocus,
    onBlur,
    onChange,
    onKeyUp,
    value,
    inputMode,
    alwaysReturnString,
  })

  return (
    <>{children}</>

    // <TextField guide={null} {...rest} {...currencyMask}>
    //   {children}
    // </TextField>
  )
}

MoneyInput.defaultProps = {
  currency: 'RUB',
  allowDecimal: false,
  allowLeadingZeroes: false,
  decimalSymbol: '.',
  integerLimit: undefined,
  decimalLimit: 2,
}

export default MoneyInput
